import React, { useState, useEffect } from "react";
import { getCombinedServicesJobs } from "../../../apiManager/admin/JobsManagement";

export const useJobs = () => {
  const [jobs, setJobs] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const getJobsData = async () => {
      try {
        setLoading(true);
        const res = await getCombinedServicesJobs(); // for paged data fetching getCombinedServicesJobs(currentPage + 1)
console.log("res usejobs", res)
        setJobs(res);
      } catch (error) {
        setError(error.message || "An error occurred while fetching data");
      } finally {
        setLoading(false);
      }
    }
    getJobsData();
  }, []); // refresh for paged data and capture click [jobId, currentPage]

  return {
    jobs,
    loading,
    error
  };
};